export default "__VITE_ASSET__DXZdgi9W__"